import { Injectable } from '@angular/core';
import {BaseProviderService} from "./base-provider.service";
import {IBibliotecaFormularioService, IBibliotecaTabelaService} from "../bibliotecaPjus/services/contrato.services";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FiltroPaginacao, ListaPaginada} from "../bibliotecaPjus/models/comum.models";
import {EnvioCnds} from "../aplicacao/models/envioCnds.model";
import {NegociarOutroValor} from "../aplicacao/models/negociar-outro-valor.model";

@Injectable({
  providedIn: 'root'
})
export class EnvioCndsService extends BaseProviderService implements IBibliotecaTabelaService<EnvioCnds, any, any>, IBibliotecaFormularioService<EnvioCnds> {
  protected module = 'Proposta';

  constructor(protected http: HttpClient) {
    super(http);
  }

  criar(): EnvioCnds {
    return new EnvioCnds();
  }

  get(id: string): Observable<EnvioCnds> {
    return this.http.get<EnvioCnds>(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Listar', '?propostaId=' + id]))
      .pipe(map(x => new EnvioCnds(x)));
  }

  list(propostaId): Observable<ListaPaginada<EnvioCnds>> {
    return this.http.get(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Listar', '?propostaId=' + propostaId]))
      .pipe(map(d => new ListaPaginada<EnvioCnds>(EnvioCnds, d)));
  }
  filter(filter: FiltroPaginacao<any, any>): Observable<ListaPaginada<EnvioCnds>> {
    return this.http.post<ListaPaginada<EnvioCnds>>(this.getUrl(this.v1, this.module, ['filter']), filter)
      .pipe(map(d => new ListaPaginada<EnvioCnds>(EnvioCnds, d)));
  }

  atualizar(model: EnvioCnds): Observable<EnvioCnds> {
    return this.http.patch<EnvioCnds>(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Enviar', model.propostaId]), model).pipe(map(x => new EnvioCnds(x)));
  }

  salvar(model: EnvioCnds): Observable<EnvioCnds> {
    return this.http.post<EnvioCnds>(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Enviar']), model).pipe(map(x => new EnvioCnds(x)));
  }

  finalizar(propostaId: string): Observable<EnvioCnds> {
    return this.http.post<EnvioCnds>(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Finalizar', '?propostaId=' + propostaId]), null).pipe(map(x => new EnvioCnds(x)));
  }

  deletar(nomeDocumento: string): Observable<EnvioCnds> {
    return this.http.delete<EnvioCnds>(this.getUrl(this.v1, this.module, ['Parceiro', 'cnd', 'Excluir',  '?nomeDocumento=' + nomeDocumento]))
      .pipe(map(x => new EnvioCnds(x)));
  }

}
